enum EContentMetricsType {

    LIKE        = 1,
    COPY_PATH   = 2,
    VIEW        = 3,
    DOWNLOAD    = 4,
    VOTE        = 5

}

export default EContentMetricsType;
